import { CardNetwork } from '@/constructs/CardNetwork';
import type { ISavedPayment, ISavedPaymentWithToken } from '../ISavedPayment';
import { MOCK_ADDRESS } from '../../Address';

export const MOCK_SAVED_PAYMENT_WITH_TOKEN = {
  uuid: '9cb1b211-7a91-4d49-9c30-b346590b10e7',
  cardType: CardNetwork.MasterCard,
  token: 'T9CB1B2117A914D499C30',
  maskedNumber: '****1234',
  expiration: '12/2025',
  billingAddress: MOCK_ADDRESS
} as ISavedPaymentWithToken;

export const MOCK_SAVED_PAYMENT = {
  ...MOCK_SAVED_PAYMENT_WITH_TOKEN,
  token: undefined // Token is not included in the non-token version
} as ISavedPayment;
